export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getVideoList: function getVideoList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/video/get",
        method: "get",
        params: data
      });
    },
    addVideo: function addVideo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/video/add",
        method: "post",
        data: data
      });
    },
    updateVideo: function updateVideo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/video/update",
        method: "post",
        data: data
      });
    }
  };
});